import React from 'react'
import Icon from '../../../atoms/icon'
import { removeWhitespaceAndSpecialChars } from '@h/commons'
import Card from '../../../atoms/card'

interface StatSnippetProps {
  name: string
  jsonBody: {
    title: string
    showIcon: boolean
    stat: {
      prefix: string
      stat: string
      suffix: string
    }
    superscriptTag?: {
      word: string
      link: string
    }
  }
  singleCol?: boolean
  twoCol?: boolean
}

const StatSnippet: React.FC<StatSnippetProps> = ({ jsonBody, name, singleCol, twoCol }) => {
  const { title, stat, showIcon, superscriptTag } = jsonBody

  const titleClass = (singleCol: boolean | undefined, twoCol: boolean | undefined) => {
    let titleClass = 'StatSnippet__title'
    if (singleCol) {
      titleClass = titleClass.concat(' StatSnippet__title--small')
    }
    if (twoCol) {
      titleClass = titleClass.concat(' StatSnippet__title--twoCol')
    }

    return titleClass
  }

  const titleWrapperClass = (singleCol: boolean | undefined, twoCol: boolean | undefined) => {
    let titleWrapperClass = 'StatSnippet__titleWrapper'

    if (singleCol) {
      titleWrapperClass = titleWrapperClass.concat(' StatSnippet__titleWrapper--singleCol')
    }
    if (twoCol) {
      titleWrapperClass = titleWrapperClass.concat(' StatSnippet__titleWrapper--twoCol')
    }

    return titleWrapperClass
  }

  try {
    return (
      <div className='StatSnippet__wrapper'>
        <Card variant='modal'>
          <div
            className={singleCol || twoCol ? 'StatSnippet--singleCol StatSnippet' : 'StatSnippet'}
            id={removeWhitespaceAndSpecialChars(name)}
          >
            <div className={titleWrapperClass(singleCol, twoCol)}>
              <div className={titleClass(singleCol, twoCol)}>
                {title}
                {superscriptTag?.word && (
                  <a
                    href={`#${removeWhitespaceAndSpecialChars(superscriptTag?.link)}`}
                    style={{ textDecoration: 'none' }}
                  >
                    <sup>{superscriptTag?.word}</sup>
                  </a>
                )}
              </div>
              {showIcon && (
                <div
                  className={
                    singleCol
                      ? 'StatSnippet__icon StatSnippet__icon--singleCol'
                      : 'StatSnippet__icon'
                  }
                  style={twoCol ? { width: '44px' } : {}} // workround to get non square icon to show
                >
                  <Icon
                    glyph={'stats-blob'}
                    size={24}
                    color='#34454E'
                    desktopSize={twoCol ? 40 : undefined}
                  />
                </div>
              )}
            </div>
            <div className='StatSnippet__stat'>
              {stat.prefix && <span className='StatSnippet__stat--prefix'>{stat.prefix}</span>}
              <span className='StatSnippet__stat--stat'>{stat.stat}</span>
              {stat.suffix && <span className='StatSnippet__stat--suffix'>{stat.suffix}</span>}
            </div>
          </div>
        </Card>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default StatSnippet
